export const CHUNK_RELOAD_KEY = 'aq:last-chunk-reload';
const RELOAD_COOLDOWN_MS = 10_000;

/** Recover once from a stale lazy-route chunk while always suppressing Vite's throw. */
export function handlePreloadError(event: Event): void {
  event.preventDefault();

  let lastReload = 0;
  try {
    lastReload = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? '0');
  } catch {
    // sessionStorage unavailable — fall through and attempt a single reload.
  }

  if (Date.now() - lastReload < RELOAD_COOLDOWN_MS) return;

  try {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch {
    // Ignore write failures; the reload below is the important part.
  }
  window.location.reload();
}
